import { render, staticRenderFns } from "./ExamManageTabs.vue?vue&type=template&id=570d6e7f"
import script from "./ExamManageTabs.vue?vue&type=script&lang=js"
export * from "./ExamManageTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports